var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setupMicrotasks = exports.runOnUIImmediately = exports.runOnUI = exports.runOnJS = exports.callMicrotasks = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _NativeReanimated = _interopRequireDefault(require("./NativeReanimated"));
var _PlatformChecker = require("./PlatformChecker");
var _shareables = require("./shareables");
var IS_JEST = (0, _PlatformChecker.isJest)();
var IS_NATIVE = !(0, _PlatformChecker.shouldBeUseWeb)();
var _runOnUIQueue = [];
var _worklet_14171424909649_init_data = {
    code: "function setupMicrotasks(){let microtasksQueue=[];let isExecutingMicrotasksQueue=false;global.queueMicrotask=function(callback){microtasksQueue.push(callback);};global.__callMicrotasks=function(){if(isExecutingMicrotasksQueue){return;}try{isExecutingMicrotasksQueue=true;for(let index=0;index<microtasksQueue.length;index+=1){microtasksQueue[index]();}microtasksQueue=[];global._maybeFlushUIUpdatesQueue();}finally{isExecutingMicrotasksQueue=false;}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["setupMicrotasks","microtasksQueue","isExecutingMicrotasksQueue","global","queueMicrotask","callback","push","__callMicrotasks","index","length","_maybeFlushUIUpdatesQueue"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AAgBO,SAAAA,eAASA,CAAA,CAAe,CAG7B,GAAI,CAAAC,eAAkC,CAAG,EAAE,CAC3C,GAAI,CAAAC,0BAA0B,CAAG,KAAK,CACtCC,MAAM,CAACC,cAAc,CAAG,SAACC,QAAoB,CAAK,CAChDJ,eAAe,CAACK,IAAI,CAACD,QAAQ,CAAC,CAChC,CAAC,CAEDF,MAAM,CAACI,gBAAgB,CAAG,UAAM,CAC9B,GAAIL,0BAA0B,CAAE,CAC9B,OACF,CACA,GAAI,CACFA,0BAA0B,CAAG,IAAI,CACjC,IAAK,GAAI,CAAAM,KAAK,CAAG,CAAC,CAAEA,KAAK,CAAGP,eAAe,CAACQ,MAAM,CAAED,KAAK,EAAI,CAAC,CAAE,CAE9DP,eAAe,CAACO,KAAK,CAAC,CAAC,CAAC,CAC1B,CACAP,eAAe,CAAG,EAAE,CACpBE,MAAM,CAACO,yBAAyB,CAAC,CAAC,CACpC,CAAC,OAAS,CACRR,0BAA0B,CAAG,KAAK,CACpC,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var setupMicrotasks = exports.setupMicrotasks = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var setupMicrotasks = function setupMicrotasks() {
        var microtasksQueue = [];
        var isExecutingMicrotasksQueue = false;
        global.queueMicrotask = function(callback) {
            microtasksQueue.push(callback);
        };
        global.__callMicrotasks = function() {
            if (isExecutingMicrotasksQueue) {
                return;
            }
            try {
                isExecutingMicrotasksQueue = true;
                for(var index = 0; index < microtasksQueue.length; index += 1){
                    microtasksQueue[index]();
                }
                microtasksQueue = [];
                global._maybeFlushUIUpdatesQueue();
            } finally{
                isExecutingMicrotasksQueue = false;
            }
        };
    };
    setupMicrotasks.__closure = {};
    setupMicrotasks.__initData = _worklet_14171424909649_init_data;
    setupMicrotasks.__workletHash = 14171424909649;
    setupMicrotasks.__stackDetails = _e;
    return setupMicrotasks;
}();
var _worklet_3679683358222_init_data = {
    code: "function callMicrotasksOnUIThread(){global.__callMicrotasks();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["callMicrotasksOnUIThread","global","__callMicrotasks"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AA2CA,SAAAA,wBAASA,CAAA,CAAwB,CAE/BC,MAAM,CAACC,gBAAgB,CAAC,CAAC,CAC3B"}',
    version: "3.5.4"
};
var callMicrotasksOnUIThread = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var callMicrotasksOnUIThread = function callMicrotasksOnUIThread() {
        global.__callMicrotasks();
    };
    callMicrotasksOnUIThread.__closure = {};
    callMicrotasksOnUIThread.__initData = _worklet_3679683358222_init_data;
    callMicrotasksOnUIThread.__workletHash = 3679683358222;
    callMicrotasksOnUIThread.__stackDetails = _e;
    return callMicrotasksOnUIThread;
}();
var callMicrotasks = exports.callMicrotasks = IS_NATIVE ? callMicrotasksOnUIThread : function callMicrotasks() {};
var _worklet_6403263515930_init_data = {
    code: "function runOnUI(worklet){const{__DEV__,IS_NATIVE,IS_JEST,NativeReanimatedModule,makeShareableCloneRecursive,callMicrotasks}=this.__closure;if(__DEV__&&IS_NATIVE&&_WORKLET){throw new Error('[Reanimated] `runOnUI` cannot be called on the UI runtime. Please call the function synchronously or use `queueMicrotask` or `requestAnimationFrame` instead.');}if(__DEV__&&IS_NATIVE&&worklet.__workletHash===undefined){throw new Error('[Reanimated] `runOnUI` can only be used on worklets.');}return function(...args){if(IS_JEST){NativeReanimatedModule.scheduleOnUI(makeShareableCloneRecursive(function(){'worklet';worklet(...args);}));return;}if(__DEV__){makeShareableCloneRecursive(worklet);makeShareableCloneRecursive(args);}_runOnUIQueue.push([worklet,args]);if(_runOnUIQueue.length===1){queueMicrotask(function(){const queue=_runOnUIQueue;_runOnUIQueue=[];NativeReanimatedModule.scheduleOnUI(makeShareableCloneRecursive(function(){'worklet';queue.forEach(function([worklet,args]){worklet(...args);});callMicrotasks();}));});}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["runOnUI","worklet","__DEV__","IS_NATIVE","IS_JEST","NativeReanimatedModule","makeShareableCloneRecursive","callMicrotasks","__closure","_WORKLET","Error","__workletHash","undefined","args","scheduleOnUI","_runOnUIQueue","push","length","queueMicrotask","queue","forEach"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AAgEO,SAAAA,OAASA,CAAQC,OACtB,CACD,OAAAC,OAAA,CAAAC,SAAA,CAAAC,OAAA,CAAAC,sBAAA,CAAAC,2BAAA,CAAAC,cAAA,OAAAC,SAAA,CAEC,GAAIN,OAAO,EAAIC,SAAS,EAAIM,QAAQ,CAAE,CACpC,KAAM,IAAI,CAAAC,KAAK,CACb,+JACF,CAAC,CACH,CACA,GAAIR,OAAO,EAAIC,SAAS,EAAIF,OAAO,CAACU,aAAa,GAAKC,SAAS,CAAE,CAC/D,KAAM,IAAI,CAAAF,KAAK,CAAC,sDAAsD,CAAC,CACzE,CACA,MAAO,UAAC,GAAGG,IAAI,CAAK,CAClB,GAAIT,OAAO,CAAE,CAUXC,sBAAsB,CAACS,YAAY,CACjCR,2BAA2B,CAAC,UAAM,CAChC,SAAS,CACTL,OAAO,CAAC,GAAGY,IAAI,CAAC,CAClB,CAAC,CACH,CAAC,CACD,OACF,CACA,GAAIX,OAAO,CAAE,CAMXI,2BAA2B,CAACL,OAAO,CAAC,CACpCK,2BAA2B,CAACO,IAAI,CAAC,CACnC,CAEAE,aAAa,CAACC,IAAI,CAAC,CAACf,OAAO,CAAyCY,IAAI,CAAC,CAAC,CAC1E,GAAIE,aAAa,CAACE,MAAM,GAAK,CAAC,CAAE,CAC9BC,cAAc,CAAC,UAAM,CACnB,KAAM,CAAAC,KAAK,CAAGJ,aAAa,CAC3BA,aAAa,CAAG,EAAE,CAClBV,sBAAsB,CAACS,YAAY,CACjCR,2BAA2B,CAAC,UAAM,CAChC,SAAS,CACTa,KAAK,CAACC,OAAO,CAAC,SAAC,CAACnB,OAAO,CAAEY,IAAI,CAAC,CAAK,CACjCZ,OAAO,CAAC,GAAGY,IAAI,CAAC,CAClB,CAAC,CAAC,CACFN,cAAc,CAAC,CAAC,CAClB,CAAC,CACH,CAAC,CACH,CAAC,CAAC,CACJ,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_6225829938965_init_data = {
    code: "function anonymous(){const{worklet,args}=this.__closure;worklet(...args);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["anonymous","worklet","args","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AAwFoC,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,IAAA,OAAAC,SAAA,CAEhCF,OAAO,CAAC,GAAGC,IAAI,CAAC,CAClB"}',
    version: "3.5.4"
};
var _worklet_11566079821664_init_data = {
    code: "function anonymous(){const{queue,callMicrotasks}=this.__closure;queue.forEach(function([worklet,args]){worklet(...args);});callMicrotasks();}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["anonymous","queue","callMicrotasks","__closure","forEach","worklet","args"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AA+GsC,SAAAA,SAAMA,CAAA,QAAAC,KAAA,CAAAC,cAAA,OAAAC,SAAA,CAEhCF,KAAK,CAACG,OAAO,CAAC,SAAC,CAACC,OAAO,CAAEC,IAAI,CAAC,CAAK,CACjCD,OAAO,CAAC,GAAGC,IAAI,CAAC,CAClB,CAAC,CAAC,CACFJ,cAAc,CAAC,CAAC,CAClB"}',
    version: "3.5.4"
};
var runOnUI = exports.runOnUI = function() {
    var _e = [
        new global.Error(),
        -7,
        -27
    ];
    var runOnUI = function runOnUI(worklet) {
        if (__DEV__ && IS_NATIVE && _WORKLET) {
            throw new Error("[Reanimated] `runOnUI` cannot be called on the UI runtime. Please call the function synchronously or use `queueMicrotask` or `requestAnimationFrame` instead.");
        }
        if (__DEV__ && IS_NATIVE && worklet.__workletHash === undefined) {
            throw new Error("[Reanimated] `runOnUI` can only be used on worklets.");
        }
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (IS_JEST) {
                _NativeReanimated.default.scheduleOnUI((0, _shareables.makeShareableCloneRecursive)(function() {
                    var _e = [
                        new global.Error(),
                        -3,
                        -27
                    ];
                    var anonymous = function anonymous() {
                        worklet.apply(void 0, args);
                    };
                    anonymous.__closure = {
                        worklet: worklet,
                        args: args
                    };
                    anonymous.__initData = _worklet_6225829938965_init_data;
                    anonymous.__workletHash = 6225829938965;
                    anonymous.__stackDetails = _e;
                    return anonymous;
                }()));
                return;
            }
            if (__DEV__) {
                (0, _shareables.makeShareableCloneRecursive)(worklet);
                (0, _shareables.makeShareableCloneRecursive)(args);
            }
            _runOnUIQueue.push([
                worklet,
                args
            ]);
            if (_runOnUIQueue.length === 1) {
                queueMicrotask(function() {
                    var queue = _runOnUIQueue;
                    _runOnUIQueue = [];
                    _NativeReanimated.default.scheduleOnUI((0, _shareables.makeShareableCloneRecursive)(function() {
                        var _e = [
                            new global.Error(),
                            -3,
                            -27
                        ];
                        var anonymous = function anonymous() {
                            queue.forEach(function(_ref) {
                                var _ref2 = (0, _slicedToArray2.default)(_ref, 2), _$worklet = _ref2[0], args = _ref2[1];
                                _$worklet.apply(void 0, (0, _toConsumableArray2.default)(args));
                            });
                            callMicrotasks();
                        };
                        anonymous.__closure = {
                            queue: queue,
                            callMicrotasks: callMicrotasks
                        };
                        anonymous.__initData = _worklet_11566079821664_init_data;
                        anonymous.__workletHash = 11566079821664;
                        anonymous.__stackDetails = _e;
                        return anonymous;
                    }()));
                });
            }
        };
    };
    runOnUI.__closure = {
        __DEV__: __DEV__,
        IS_NATIVE: IS_NATIVE,
        IS_JEST: IS_JEST,
        NativeReanimatedModule: _NativeReanimated.default,
        makeShareableCloneRecursive: _shareables.makeShareableCloneRecursive,
        callMicrotasks: callMicrotasks
    };
    runOnUI.__initData = _worklet_6403263515930_init_data;
    runOnUI.__workletHash = 6403263515930;
    runOnUI.__stackDetails = _e;
    return runOnUI;
}();
var _worklet_4938484458493_init_data = {
    code: "function runOnUIImmediately(worklet){const{__DEV__,IS_NATIVE,NativeReanimatedModule,makeShareableCloneRecursive}=this.__closure;if(__DEV__&&IS_NATIVE&&_WORKLET){throw new Error('[Reanimated] `runOnUIImmediately` cannot be called on the UI runtime. Please call the function synchronously or use `queueMicrotask` or `requestAnimationFrame` instead.');}if(__DEV__&&IS_NATIVE&&worklet.__workletHash===undefined){throw new Error('[Reanimated] `runOnUIImmediately` can only be used on worklets.');}return function(...args){NativeReanimatedModule.scheduleOnUI(makeShareableCloneRecursive(function(){'worklet';worklet(...args);}));};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["runOnUIImmediately","worklet","__DEV__","IS_NATIVE","NativeReanimatedModule","makeShareableCloneRecursive","__closure","_WORKLET","Error","__workletHash","undefined","args","scheduleOnUI"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AAmIO,SAAAA,kBAASA,CAAmBC,OACjC,CACD,OAAAC,OAAA,CAAAC,SAAA,CAAAC,sBAAA,CAAAC,2BAAA,OAAAC,SAAA,CAEC,GAAIJ,OAAO,EAAIC,SAAS,EAAII,QAAQ,CAAE,CACpC,KAAM,IAAI,CAAAC,KAAK,CACb,0KACF,CAAC,CACH,CACA,GAAIN,OAAO,EAAIC,SAAS,EAAIF,OAAO,CAACQ,aAAa,GAAKC,SAAS,CAAE,CAC/D,KAAM,IAAI,CAAAF,KAAK,CACb,iEACF,CAAC,CACH,CACA,MAAO,UAAC,GAAGG,IAAI,CAAK,CAClBP,sBAAsB,CAACQ,YAAY,CACjCP,2BAA2B,CAAC,UAAM,CAChC,SAAS,CACTJ,OAAO,CAAC,GAAGU,IAAI,CAAC,CAClB,CAAC,CACH,CAAC,CACH,CAAC,CACH"}',
    version: "3.5.4"
};
var _worklet_6225829938965_init_data2 = {
    code: "function anonymous(){const{worklet,args}=this.__closure;worklet(...args);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["anonymous","worklet","args","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AAmJkC,SAAAA,SAAMA,CAAA,QAAAC,OAAA,CAAAC,IAAA,OAAAC,SAAA,CAEhCF,OAAO,CAAC,GAAGC,IAAI,CAAC,CAClB"}',
    version: "3.5.4"
};
var runOnUIImmediately = exports.runOnUIImmediately = function() {
    var _e = [
        new global.Error(),
        -5,
        -27
    ];
    var runOnUIImmediately = function runOnUIImmediately(worklet) {
        if (__DEV__ && IS_NATIVE && _WORKLET) {
            throw new Error("[Reanimated] `runOnUIImmediately` cannot be called on the UI runtime. Please call the function synchronously or use `queueMicrotask` or `requestAnimationFrame` instead.");
        }
        if (__DEV__ && IS_NATIVE && worklet.__workletHash === undefined) {
            throw new Error("[Reanimated] `runOnUIImmediately` can only be used on worklets.");
        }
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
                args[_key2] = arguments[_key2];
            }
            _NativeReanimated.default.scheduleOnUI((0, _shareables.makeShareableCloneRecursive)(function() {
                var _e = [
                    new global.Error(),
                    -3,
                    -27
                ];
                var anonymous = function anonymous() {
                    worklet.apply(void 0, args);
                };
                anonymous.__closure = {
                    worklet: worklet,
                    args: args
                };
                anonymous.__initData = _worklet_6225829938965_init_data2;
                anonymous.__workletHash = 6225829938965;
                anonymous.__stackDetails = _e;
                return anonymous;
            }()));
        };
    };
    runOnUIImmediately.__closure = {
        __DEV__: __DEV__,
        IS_NATIVE: IS_NATIVE,
        NativeReanimatedModule: _NativeReanimated.default,
        makeShareableCloneRecursive: _shareables.makeShareableCloneRecursive
    };
    runOnUIImmediately.__initData = _worklet_4938484458493_init_data;
    runOnUIImmediately.__workletHash = 4938484458493;
    runOnUIImmediately.__stackDetails = _e;
    return runOnUIImmediately;
}();
var _worklet_14892326408241_init_data = {
    code: "function anonymous(){}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["anonymous"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AA4Ja,SAAAA,SAEXA,CAAA"}',
    version: "3.5.4"
};
if (__DEV__ && IS_NATIVE) {
    var f = function() {
        var _e = [
            new global.Error(),
            1,
            -27
        ];
        var anonymous = function anonymous() {};
        anonymous.__closure = {};
        anonymous.__initData = _worklet_14892326408241_init_data;
        anonymous.__workletHash = 14892326408241;
        anonymous.__stackDetails = _e;
        return anonymous;
    }();
    if (f.__workletHash === undefined) {
        throw new Error("[Reanimated] Failed to create a worklet. See `https://docs.swmansion.com/react-native-reanimated/docs/guides/troubleshooting#failed-to-create-a-worklet` for more details.");
    }
}
function runWorkletOnJS(worklet) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++){
        args[_key3 - 1] = arguments[_key3];
    }
    worklet.apply(void 0, args);
}
var _worklet_12204705605629_init_data = {
    code: "function runOnJS(fun){const runOnJS=this._recur;const{IS_NATIVE,runWorkletOnJS,makeShareableCloneOnUIRecursive}=this.__closure;if(!IS_NATIVE||!_WORKLET){return function(...args){return queueMicrotask(args.length?function(){return fun(...args);}:fun);};}if(fun.__workletHash){return function(...args){return runOnJS(runWorkletOnJS)(fun,...args);};}if(fun.__remoteFunction){fun=fun.__remoteFunction;}return function(...args){_scheduleOnJS(fun,args.length>0?makeShareableCloneOnUIRecursive(args):undefined);};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts",
    sourceMap: '{"version":3,"names":["runOnJS","fun","_recur","IS_NATIVE","runWorkletOnJS","makeShareableCloneOnUIRecursive","__closure","_WORKLET","args","queueMicrotask","length","__workletHash","__remoteFunction","_scheduleOnJS","undefined"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/threads.ts"],"mappings":"AA8LO,SAAAA,OAASA,CAAQC,GACtB,CAID,OAAAD,OAAA,MAAAE,MAAA,OAAAC,SAAA,CAAAC,cAAA,CAAAC,+BAAA,OAAAC,SAAA,CAIC,GAAI,CAACH,SAAS,EAAI,CAACI,QAAQ,CAAE,CAE3B,MAAO,UAAC,GAAGC,IAAI,QACb,CAAAC,cAAc,CACZD,IAAI,CAACE,MAAM,CACP,iBAAO,CAAAT,GAAG,CAAoC,GAAGO,IAAI,CAAC,GACrDP,GACP,CAAC,GACL,CACA,GAAKA,GAAG,CAAgBU,aAAa,CAAE,CAIrC,MAAO,UAAC,GAAGH,IAAI,QACb,CAAAR,OAAO,CAACI,cAAiC,CAAC,CACxCH,GAAG,CACH,GAAGO,IACL,CAAC,GACL,CACA,GAAKP,GAAG,CAAkBW,gBAAgB,CAAE,CAK1CX,GAAG,CAAIA,GAAG,CAAkBW,gBAAgB,CAC9C,CACA,MAAO,UAAC,GAAGJ,IAAI,CAAK,CAClBK,aAAa,CACXZ,GAAG,CAGHO,IAAI,CAACE,MAAM,CAAG,CAAC,CAEVL,+BAA+B,CAACG,IAAI,CAAC,CACtCM,SACN,CAAC,CACH,CAAC,CACH"}',
    version: "3.5.4"
};
var runOnJS = exports.runOnJS = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var runOnJS = function runOnJS(fun) {
        if (!IS_NATIVE || !_WORKLET) {
            return function() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
                    args[_key4] = arguments[_key4];
                }
                return queueMicrotask(args.length ? function() {
                    return fun.apply(void 0, args);
                } : fun);
            };
        }
        if (fun.__workletHash) {
            return function() {
                for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
                    args[_key5] = arguments[_key5];
                }
                return runOnJS(runWorkletOnJS).apply(void 0, [
                    fun
                ].concat(args));
            };
        }
        if (fun.__remoteFunction) {
            fun = fun.__remoteFunction;
        }
        return function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
                args[_key6] = arguments[_key6];
            }
            _scheduleOnJS(fun, args.length > 0 ? (0, _shareables.makeShareableCloneOnUIRecursive)(args) : undefined);
        };
    };
    runOnJS.__closure = {
        IS_NATIVE: IS_NATIVE,
        runWorkletOnJS: runWorkletOnJS,
        makeShareableCloneOnUIRecursive: _shareables.makeShareableCloneOnUIRecursive
    };
    runOnJS.__initData = _worklet_12204705605629_init_data;
    runOnJS.__workletHash = 12204705605629;
    runOnJS.__stackDetails = _e;
    return runOnJS;
}();
